import { Grid, styled } from "@mui/material";

export const Wrapper = styled(Grid)(() => ({
  paddingTop: "32px !important",
}));

export const Title = styled("span")(() => ({
  font: "500 24px/32px Manrope",
  color: "#475467",
  textAlign: "center",
}));

export const DescriptionContainer = styled(Grid)(() => ({
  display: "flex",
}));

export const Description = styled("span")(() => ({
  font: "400 14px/20px Manrope",
  color: "#475467",
  textAlign: "center",
}));
